export const GET_CALC_POLY = 'GET_CALC_POLY';
export const GET_CALC_POLY_SUCCESS = 'GET_CALC_POLY_SUCCESS';
export const GET_CALC_POLY_FAIL = 'GET_CALC_POLY_FAIL';

export const GET_AREA_REPORT = 'GET_AREA_REPORT';
export const GET_AREA_REPORT_SUCCESS = 'GET_AREA_REPORT_SUCCESS';
export const GET_AREA_REPORT_FAIL = 'GET_AREA_REPORT_FAIL';

export const GET_ENFORCEMENT_REPORT = 'GET_ENFORCEMENT_REPORT';
export const GET_ENFORCEMENT_REPORT_SUCCESS = 'GET_ENFORCEMENT_REPORT_SUCCESS';
export const GET_ENFORCEMENT_REPORT_FAIL = 'GET_ENFORCEMENT_REPORT_FAIL';

export const GET_EDUCATION_REPORT = 'GET_EDUCATION_REPORT';
export const GET_EDUCATION_REPORT_SUCCESS = 'GET_EDUCATION_REPORT_SUCCESS';
export const GET_EDUCATION_REPORT_FAIL = 'GET_EDUCATION_REPORT_FAIL';

export const POST_RETAIL_LANDSCAPE = 'POST_RETAIL_LANDSCAPE';
export const POST_RETAIL_LANDSCAPE_SUCCESS = 'POST_RETAIL_LANDSCAPE_SUCCESS';
export const POST_RETAIL_LANDSCAPE_FAIL = 'POST_RETAIL_LANDSCAPE_FAIL';

export const POST_NEW_REPORT = 'POST_NEW_REPORT';
export const POST_NEW_REPORT_SUCCESS = 'POST_NEW_REPORT_SUCCESS';
export const POST_NEW_REPORT_FAIL = 'POST_NEW_REPORT_FAIL';

export const GET_EDUCATION_FORMS = 'GET_EDUCATION_FORMS';
export const GET_EDUCATION_FORMS_SUCCESS = 'GET_EDUCATION_FORMS_SUCCESS';
export const GET_EDUCATION_FORMS_FAIL = 'GET_EDUCATION_FORMS_FAIL';

export const GET_ASSESSMENTS_FORMS = 'GET_ASSESSMENTS_FORMS';
export const GET_ASSESSMENTS_FORMS_SUCCESS = 'GET_ASSESSMENTS_FORMS_SUCCESS';
export const GET_ASSESSMENTS_FORMS_FAIL = 'GET_ASSESSMENTS_FORMS_FAIL';

export const GET_ENFORCEMENT_FORMS = 'GET_ENFORCEMENT_FORMS';
export const GET_ENFORCEMENT_FORMS_SUCCESS = 'GET_ENFORCEMENT_FORMS_SUCCESS';
export const GET_ENFORCEMENT_FORMS_FAIL = 'GET_ENFORCEMENT_FORMS_FAIL';

export const GET_ENFORCEMENT_AGENCIES = 'GET_ENFORCEMENT_AGENCIES';
export const GET_ENFORCEMENT_AGENCIES_SUCCESS = 'GET_ENFORCEMENT_AGENCIES_SUCCESS';
export const GET_ENFORCEMENT_AGENCIES_FAIL = 'GET_ENFORCEMENT_AGENCIES_FAIL';

export const RESET_CALC_POLY = 'RESET_CALC_POLY';
